<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">医疗服务和程序 (门诊)</h3>
            <div class="img-wrap">
                <img alt="" class="" src="/resource/img/">
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">初诊患者 (首次就诊)</h3>
            <h4 class="depth bullet02">没有预约的直接就诊服务</h4>
            <p class="depth">
                请在B1-3楼填写服务申请表. 取号排队, 把服务申请表, 您的健康保险卡和您的身份证交给显示您所持号码的前台. 前台将发放门诊服务预约卡和医疗服务卡. 请将门诊服务预约卡提交给门诊部.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">复诊患者 (复诊作后续治疗)</h3>
            <h4 class="depth bullet02">如果您已经预约</h4>
            <p class="depth">请于预约时间至少十分钟之前到达, 并直接前往就诊科室.</p>
            <p class="depth">将预约卡提交到您要就诊的科室.</p>
            <h4 class="depth bullet02">如果您是通过电话或在线 (电话, 互联网或移动电话) 预约的</h4>
            <p class="depth">请于预约时间至少十分钟之前到达, 并直接前往就诊科室.</p>
            <p class="depth">请向该科室的接待处出示您的预约通知短信.</p>
            <h4 class="depth bullet02">直接就诊服务, 无预约</h4>
            <p class="depth">取号排队, 把服务申请表和您的健康保险卡交给显示您所持号码的前台. 前台将发放门诊预约卡. 将此门诊预约卡交至此科室.</p>
            <p class="depth font-sub">※ 根据科室的具体情况, 没有预约的科室可能会提前关闭.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>